// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"styles_callToAction__wuE7j","icon":"styles_icon__WxbEg","label":"styles_label__JdDZa"};